// We might want to generate these plans from the backend automatically.
// For now, we'll just use these fixtures.

/**
 * Every plan a subscriber's role can name, lowest tier first.
 *
 * The pre-2025 `Premium` and `Business` roles are gone: those subscribers were
 * migrated onto `Creator` and `Pro` while keeping their original Stripe plan
 * (and price). `Business` here is the 2026 top tier, nothing to do with the
 * old plan of the same name — see CONTEXT.md.
 */
export const plans = [
  {
    name: 'Free',
  },
  {
    name: 'Essentials',
  },
  {
    name: 'Creator',
  },
  {
    name: 'Pro',
  },
  {
    name: 'Business',
  },
] as const;

export type Plan = (typeof plans)[number];
